// Canvas — starred tables on My Desk. Add or remove from here, or pin on the page.
import type { JSX } from 'preact';
import { PinnedBoard } from './PinnedBoard';

export function Canvas({ chromeless = false }: { chromeless?: boolean } = {}): JSX.Element {
  return (
    <PinnedBoard
      kind="table"
      title="Canvas"
      empty="Nothing pinned."
      testId="desk-canvas"
      className="desk-canvas"
      allowAdd
      allowRemove
      chromeless={chromeless}
    />
  );
}
